import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { bootstrap } from '@/features/auth/authThunks';
import type { RootState } from '@/app/store';
import SplashScreen from '@/components/common/SplashScreen';
import { useMinSplash } from '@/hooks/useMinSplash';
import NotFoundPage from '@/pages/NotFound.tsx';

export default function NotFoundPublic() {
  const dispatch = useAppDispatch();
  const { user, bootstrapped, loading } = useAppSelector((s: RootState) => s.auth);

  useEffect(() => {
    if (!bootstrapped && !loading) {
      dispatch(bootstrap());
    }
  }, [bootstrapped, loading, dispatch]);

  const pending = !bootstrapped || loading;
  const showSplash = useMinSplash(pending, 600);

  if (showSplash) {
    return <SplashScreen />;
  }

  return <NotFoundPage authenticated={!!user} />;
}
